import createSimpleStore from '../createSimpleStore'

export default createSimpleStore()
